import React from 'react';
import { Sparkles } from 'lucide-react';
import { useAI } from './AIContext';
import { cn } from '@/utils/cn';

export function AIFloatingButton() {
  const { openChat, isOpen, maxLimit } = useAI();

  if (isOpen || maxLimit === 0) return null;

  return (
    <button
      onClick={() => openChat()}
      className={cn(
        "fixed bottom-8 right-6 z-[9999] lg:hidden",
        "w-14 h-14 rounded-full shadow-md",
        "bg-gradient-to-br from-emerald-600 to-teal-700 text-white",
        "flex items-center justify-center transition-all duration-300",
        "hover:scale-110 active:scale-95 animate-bounce"
      )}
      aria-label="Mở Trợ lý AI"
    >
      <Sparkles size={24} className="animate-pulse" />
    </button>
  );
}
